import { render, staticRenderFns } from "./MotorProposalVehicle.vue?vue&type=template&id=54df200e&"
import script from "./MotorProposalVehicle.vue?vue&type=script&lang=js&"
export * from "./MotorProposalVehicle.vue?vue&type=script&lang=js&"
import style0 from "./MotorProposalVehicle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorProposalVehicle.vue"
export default component.exports